import { twMerge } from "tailwind-merge"

import { FIELD_ERROR_BASE_CLASSES } from "@/constants/forms"

interface FieldErrorError {
  message?: string
}

interface FieldErrorProps {
  error?: FieldErrorError
  className?: string
}

/**
 * Displays an error message for a form field
 *
 * @param props The component's props
 * @param props.error The error object to display. Optional
 * @param props.className The class name to apply to the error message. Optional
 *
 * @deprecated Use UI Kit components prefixed with Aeros for uncontrolled usage or components prefixed with Form for controlled usage.
 *
 * @example
 * ```tsx
 * <FieldError error={{ message: "This field is required" }} />
 * ```
 */
const FieldError = ({ error, className, ...rest }: FieldErrorProps): React.ReactElement | null => {
  const errorMessage = error?.message

  return errorMessage ? (
    <p className={twMerge(FIELD_ERROR_BASE_CLASSES, className)} {...rest}>
      {errorMessage}
    </p>
  ) : (
    <p className={twMerge("invisible", FIELD_ERROR_BASE_CLASSES, className)} {...rest}>
      &nbsp;
    </p>
  )
}

export default FieldError
export { FieldError }
export type { FieldErrorProps }
